import React from 'react';
import {observer} from 'mobx-react';
import {Panel, FormLayout, Input} from 'components';
import {t} from 'shared/core';

const EvidenceMaximumForm = observer(({uiState}) => {
  const {currentCoverage, errors} = uiState;

  if (!currentCoverage.evidenceMaximumRequired) return null;

  return (
    <div>
      <Panel.Separator />
      <Panel.Subheader title={t('taxable_benefits.Coverage Maximums')}/>
      <FormLayout>
        <FormLayout.Group>
          <Input
            value={currentCoverage.nonEvidenceMaximum}
            onChange={e => currentCoverage.merge({nonEvidenceMaximum: e.target.value})}
            label='taxable_benefits.Non-evidence Maximum'
            disabled={currentCoverage.volumeType === 'amount'}
            errorMessage={errors.nonEvidenceMaximum}
          />
          <Input
            value={currentCoverage.evidenceMaximum}
            onChange={e => currentCoverage.merge({evidenceMaximum: e.target.value})}
            label='taxable_benefits.Evidence Maximum'
            disabled={currentCoverage.volumeType === 'amount'}
            errorMessage={errors.evidenceMaximum}
          />
        </FormLayout.Group>
      </FormLayout>
    </div>
  );
});

export default EvidenceMaximumForm;
